"use strict";
exports.__esModule = true;
//# sourceMappingURL=result-history-investors-slice.js.map